export const APPLY_HIGHLIGHT_LAYERS = "APPLY_HIGHLIGHT_LAYERS";

export const applyHighlightLayersAction = (baselineLayer: any, workspaceLayer: any) => {
    return {
        type: APPLY_HIGHLIGHT_LAYERS,
        baselineLayer: baselineLayer,
        workspaceLayer: workspaceLayer,
    };
};
